import React, { useState, useEffect } from 'react';
import { APIROOT } from '../../../Helpers/configs';

import InstallTicketCabinetInfo from './InstallTicketCabinetInfoV2';

import { Box, Grid, Divider, Button } from '@mui/material';


const InstallTicketCabinet = (props) => {

//validationError,setvalidationError
const {serialsDataList, addSerial, deleteSerial, cabinetTypeList, customerCategory, updateSerialWithCallback} = props;

  return (
    <Box>
      {serialsDataList.map((obj, index) => {
        return (
          <Box key={index} margin='10px'>
            <InstallTicketCabinetInfo
              // validationError={validationError[index]}
              // // setvalidationError={(error) => {
              // //   setvalidationError((currentError) => {
              // //     let tempError = currentError;
              // //     tempError[index] = error;
              // //     return tempError;
              // //   });
              // // }}
              // setvalidationErrorWithCallback={updateValidationWithCallback}
              customerCategory={customerCategory}
              listId={index}
              cabinetData={obj}
              serialsDataList={serialsDataList}
              addSerial={addSerial}
              deleteSerial={deleteSerial}
              cabinetTypeList={cabinetTypeList}
              updateSerialWithCallback={updateSerialWithCallback}
            />
            <Grid
              container
              xs={12}
              md={12}
              flexDirection='row'
              rowGap={1}
              // columnGap={1}
              alignContent='flex-start'
            >
            </Grid>
            <Divider />
          </Box>
        );
      })}
    </Box>
  );
};

export default InstallTicketCabinet;
